// Dots — garbage bet. GolfGamesScorecard tracks "dots" (birdies, greenies,
// sandies, …) live in the scorecard UI; its scoring engine routes 'dots' to
// calcStroke for standings (no canonical payout formula in code). We mirror
// that: calcStroke standings (imported) + a dot tally worth `dotValue` each.
// The sandbox derives dots deterministically from the sample (birdies-or-better).
export { calcStroke } from './ggStrokePlay.js'

/** Tally dots per player → count + dollar value (dots × dotValue), sorted. */
export function computeDots(players, dotsByPlayer = {}, dotValue = 1) {
  return (players || [])
    .map((p) => {
      const dots = dotsByPlayer[p.id] || 0
      return { id: p.id, name: p.name, dots, value: dots * (Number(dotValue) || 0) }
    })
    .sort((a, b) => b.dots - a.dots)
}

/** Score-derived dots: one dot per birdie-or-better hole. */
export function dotsFromScores(players, pars) {
  const out = {}
  for (const p of players || []) {
    out[p.id] = p.scores.reduce((n, s, h) => n + (s != null && s < (pars[h] ?? 4) ? 1 : 0), 0)
  }
  return out
}

/** One-tap junk dots (greenie / sandy / closest-to-pin) → { pid: count }. */
export function junkDots(junkEvents = []) {
  const out = {}
  for (const e of junkEvents) if (e && e.playerId != null) out[e.playerId] = (out[e.playerId] || 0) + 1
  return out
}

/** Merge any number of { pid: count } dot maps. */
export function combineDots(...maps) {
  const out = {}
  for (const m of maps) for (const [id, n] of Object.entries(m || {})) out[id] = (out[id] || 0) + n
  return out
}

// ── Auto-settle (ON): score dots + one-tap junk dots, combined tally ─────────
export function autoDots(players, pars, junkEvents = [], dotValue = 1) {
  const combined = combineDots(dotsFromScores(players, pars), junkDots(junkEvents))
  return computeDots(players, combined, dotValue)
}
